import { LOAD_SUCCESS_AUTH, LOAD_FAIL_AUTH } from "../actions/utilisateurAction";
import { INCREMENT_SUCCESS_SOCIETES, UPDATE_SUCCESS_SOCIETES } from "../actions/societeAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_AUTH:
      const utilisateur = action.payload;
      const { utilisateur_societe } = utilisateur;

      action.payload = {
        ...utilisateur,
        key: 0,
        societe_id: utilisateur_societe.societe_id,
        dossier_id: utilisateur_societe.societe_dossier_id,
      };

      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_AUTH:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case INCREMENT_SUCCESS_SOCIETES:
      if (!state.data) return state;

      return {
        ...state,
        data: {
          ...state.data,
          utilisateur_societe: {
            ...state.data.utilisateur_societe,
            invoice_counter: action.payload.invoice_counter,
          },
        },
      };
    case UPDATE_SUCCESS_SOCIETES:
      if (!state.data || action.payload.societe_id !== state.data.utilisateur_societe.societe_id)
        return state;

      return {
        ...state,
        data: {
          ...state.data,
          utilisateur_societe: {
            ...state.data.utilisateur_societe,
            ...action.payload,
          },
        },
      };
    default:
      return state;
  }
}
